// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"336":"87af70ad200ecb6a","2888":"ed202bee31f9130b"}[chunkId] + ".css";
};